import { c as _c } from "react/compiler-runtime";
import { FormSelect, FormSelectIdType, FormSelectProps } from '@systemeio/ui';
import { Controller, ControllerProps, FieldPath, FieldValues, PathValue, UseFormSetValue } from 'react-hook-form';
type FormSelectRhfProps<T extends FormSelectIdType, TValues extends FieldValues, TName extends FieldPath<TValues>> = Omit<FormSelectProps<T>, 'onChange' | 'value'> & Omit<ControllerProps<TValues, TName>, 'render'> & {
  setValue: UseFormSetValue<TValues>;
};
function FormSelectRhf(props) {
  const $ = _c(17);
  let control;
  let name;
  let restProps;
  let rules;
  let setValue;
  if ($[0] !== props) {
    ({
      setValue,
      control,
      name,
      rules,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = control;
    $[2] = name;
    $[3] = restProps;
    $[4] = rules;
    $[5] = setValue;
  } else {
    control = $[1];
    name = $[2];
    restProps = $[3];
    rules = $[4];
    setValue = $[5];
  }
  let t0;
  if ($[6] !== name || $[7] !== setValue) {
    t0 = value => setValue(name, value as PathValue<TValues, TName>);
    $[6] = name;
    $[7] = setValue;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  const handleChange = t0;
  let t1;
  if ($[9] !== handleChange || $[10] !== restProps) {
    t1 = t2 => {
      const {
        field
      } = t2;
      return <FormSelect {...restProps} value={field.value} onChange={handleChange} />;
    };
    $[9] = handleChange;
    $[10] = restProps;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== control || $[13] !== name || $[14] !== rules || $[15] !== t1) {
    t2 = <Controller control={control} name={name} rules={rules} render={t1} />;
    $[12] = control;
    $[13] = name;
    $[14] = rules;
    $[15] = t1;
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  return t2;
}
export default FormSelectRhf;